import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApplicantService } from '@shared/services/forms/applicant.service';
import { concatMap } from 'rxjs/operators';

@Component({
  selector: 'app-discount-code-dialog',
  templateUrl: './discount-code-dialog.component.html',
  styleUrls: ['./discount-code-dialog.component.scss']
})
export class DiscountCodeDialogComponent implements OnInit {


  formGroup: FormGroup;
  showMessage = false;
  saveSuccess: boolean;
  validDiscountCode: boolean;
  @Output() oidAction = new EventEmitter<string>();
  loading = false;

  constructor(public dialogRef: MatDialogRef<DiscountCodeDialogComponent>, private applicantService: ApplicantService) { }

  ngOnInit() {
    this.formGroup = new FormGroup({
      discountCodeControl: new FormControl()
    });

    var discountCode = localStorage.getItem('discountCode');
    if (discountCode) {
      this.formGroup.get('discountCodeControl').setValue(discountCode);
    }

  }

  validateCode() {
    const code = this.formGroup.get('discountCodeControl').value.trim();
    this.loading = true;
    this.applicantService.validateDiscountCode(code)
      .pipe(concatMap(isValid => {
        if (isValid) {
          this.validDiscountCode = true;
          return this.applicantService.saveDiscountCode(code)
        } else {
          this.validDiscountCode = false;
          return null;
        }
      }), concatMap(() => {
        return this.applicantService.getOrderId(code);
      }
      )).subscribe(() => {
        this.saveSuccess = true;
        this.loading = false;
      }, (error) => {
        this.loading = false
        this.saveSuccess = false;
      });
    this.showMessage = true;

  }
}

